import { graphql, useStaticQuery } from 'gatsby';
import { BiBarChartSquare } from '@react-icons/all-files/bi/BiBarChartSquare';
import { BiHomeAlt } from '@react-icons/all-files/bi/BiHomeAlt';
import { BiCalendarCheck } from '@react-icons/all-files/bi/BiCalendarCheck';

function useBuildToRentData() {
  const data = useStaticQuery(graphql`
    {
      contentfulPage(nameid: { eq: "Build to rent page" }) {
        metaTitle
        metaDescription {
          metaDescription
        }
        heroSections: hero_sections {
          botton1Text
          button1Id
          button1Style
          button1Active
          button1Url
          image {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: TRACED_SVG
            )
            title
            description
          }
          slug
          secondaryDescription
          primaryTitle
          secondaryTitle
          tertiaryTitle
          primaryDescription {
            primaryDescription
          }
          isFullHeight
        }
        cardsgridwithchildren {
          cardsgridwithchildrendata {
            moveUp
            icon
            title
            description {
              description
            }
          }
          isInline
          isChildLeft
          title
          displayStarSvg1
          padding
        }
        dashboardOverview: dashboard_overview {
          id
          description {
            description
          }
          mode
          squareSvg
          title
          onClick
          buttonId
          ctaText
        }
        complianceMonitoring: compliance_monitoring {
          formcta {
            id
            title
            titleColor
            mode
            description {
              description
            }
            ctaText
          }
          displayStarSvg
          isImageLeft
          imageTop
          mode
          name
          padding
          image {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: TRACED_SVG
            )
            title
          }
          removeMargin
        }
        ctaWithText: cta_section {
          id
          title
          description {
            description
          }
          button1Url
          button1Text
          button1Style
          button1Active
        }
        ctaWithForm: cta_section_with_form {
          description {
            description
          }
          image {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: TRACED_SVG
            )
            title
          }
          title
          isImageLeft
        }
        split_section_with_image {
          id
          alignChildren
          background
          containerPadding
          displayStarSvg
          hasCircleBg
          imageContainerPosition
          isImageLeft
          showOverlayImage
          showOverlaySvg
          starSvgMoveY
          starSvgPositionLeft
          starSvgPositionTop
          starSvgWidth
          margin
          mode
          name
          image {
            gatsbyImageData(
              quality: 100
              layout: CONSTRAINED
              placeholder: TRACED_SVG
            )
            title
            description
          }
          servicescta {
            btn1Accent
            btn1BgColor
            btn1Id
            btn1Url
            btn1Text
            btn1Variant
            button2BgColor
            button2Id
            button2Variant
            description {
              description
            }
            heading3Title
            displayFeatures
            titleChildren1Color
            titleChildren1title
            titleChildren2Color
            titleChildren2title
            withArrow
          }
        }
      }
    }
  `);

  if (
    data.contentfulPage?.cardsgridwithchildren[0]?.cardsgridwithchildrendata
  ) {
    // The data should have the format
    // {
    //   column_one: [{
    //     icon: ReactElement,
    //     description: string,
    //     moveUp: bool,
    //   }]
    //   column_two: [{
    //     icon: ReactElement,
    //     description: string,
    //     moveUp: bool,
    //   }]
    // }
    const cardsgridwithchildrendata = Array.from(
      data.contentfulPage.cardsgridwithchildren[0].cardsgridwithchildrendata,
    ).reverse();

    data.contentfulPage.cardsgridwithchildren[0].cardsgridwithchildrendata = cardsgridwithchildrendata.reduce(
      (acc, item, index) => {
        let icon = BiBarChartSquare;
        if (index === 1) {
          icon = BiCalendarCheck;
        }
        if (index === 2) {
          icon = BiHomeAlt;
        }
        return {
          ...acc,
          [index]: [
            {
              ...item,
              icon,
              description: item.description.description,
            },
          ],
        };
      },
      {},
    );
  }

  // Earn Rental Return While
  data.contentfulPage.earnRentalReturnWhile = data.contentfulPage?.split_section_with_image.find(
    section => section.id === 'f4c7b8ac-bc98-5205-8edd-50358688c139',
  );
  data.contentfulPage.findThePerfectTenants = data.contentfulPage?.split_section_with_image.find(
    section => section.id === 'e4c61f6f-a422-5a35-a3e6-6c6ecdb93124',
  );

  data.contentfulPage.keepUpWithTheMarket = data.contentfulPage?.split_section_with_image.find(
    section => section.id === 'c90c36ff-2b89-5073-a743-20eda35f4ce6',
  );

  data.contentfulPage.lowVoidTimes = data.contentfulPage?.split_section_with_image.find(
    section => section.id === 'ffd6d2f4-4e06-588f-97c6-3251d3888da0',
  );
  return data;
}

export default useBuildToRentData;
